import styled from "@emotion/styled";

export const BreadcrumpWrapper = styled.div(({theme}) => ({
  gridColumn: "1/-1",
  flexDirection: "row",
  alignItems: "center",
  flexWrap: "wrap",
  wordBreak: "break-word",
  paddingBlock: theme?.breakpoints?.isMobile ? 8 : 16,
  marginBottom: 15,
}));

export const Separator = styled.div(({theme, isTransparent = false, height = 10}) => ({
  display: "inline-block",
  width: 1,
  height: height,
  marginInline: 10,
  fontWeight: 400,
  backgroundColor: isTransparent ? theme?.colors?.primaryWhite : "black",
}));
